var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepper"},[_c('div',{staticClass:"step-desktop"},[_c('img',{attrs:{"src":_vm.imageSrcD,"alt":"steps"}})]),_vm._v(" "),_c('div',{staticClass:"step-mobile"},[_c('img',{attrs:{"src":_vm.imageSrcM,"alt":"step"}})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dd13fab","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/app/components/Stepper.vue
// module id = 9C5D
// module chunks = 1